<template>
  <div class="date-separator" role="separator" :aria-label="formattedDate">
    <span class="date-separator-pill">{{ formattedDate }}</span>
  </div>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: 'DateSeparator',
  props: {
    date: {
      type: [String, Number, Date],
      required: true
    }
  },
  computed: {
    formattedDate() {
      if (!this.date) return '';
      
      const date = typeof this.date === 'number' ? new Date(this.date) : new Date(this.date);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      // Check if date is today
      if (date.toDateString() === today.toDateString()) {
        return 'امروز';
      }
      
      // Check if date is yesterday
      if (date.toDateString() === yesterday.toDateString()) {
        return 'دیروز';
      }
      
      // Format as Persian date
      return moment(date).format('jYYYY/jMM/jDD');
    }
  }
}
</script>

<style scoped>
.date-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
  direction: rtl;
}

.date-separator-pill {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  background: #F0F0F0;
  padding: 6px 14px;
  border-radius: 20px;
  white-space: nowrap;
}
</style>


